export const extractNumber = value => {
  if (!value) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  const normalized = value.replace(',', '.');
  const match = normalized.match(/-?\d+(\.\d+)?/);
  return match ? parseFloat(match[0]) : 0;
};